<template>
  <div class="report-content">
    <button
      type="button"
      class="report-content-button"
      @click="handleContentReportOpenClick"
    >
      <img class="icon" src="@/assets/images/ic_siren.svg" alt="icon" />
      {{ $t('common.labels.report') }}
    </button>
    <ConfirmReportContentModal
      v-if="isShowConfirmContentReportModal"
      class="content-report-modal"
      @ok="handleConfirmContentReportClick"
      @cancel="isShowConfirmContentReportModal = false"
    />

    <ReportContentModal
      v-if="isShowContentReportModal"
      class="content-report-modal"
      :card="card"
      :page="page"
      :selectedOption="selectedOption"
      :answerOption="answerOption"
      :enteredValue="enteredValue"
      :answerValue="answerValue"
      :quizSolved="quizSolved"
      :isCorrect="isCorrect"
      @ok="handleContentReportSent()"
      @cancel="isShowContentReportModal = false"
    />

    <CustomModal
      v-if="isShowContentReportSuccessModal"
      id="content-report-success-modal"
      class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
      :hide-header="true"
      :ok-title="$t('common.confirm')"
      @ok="isShowContentReportSuccessModal = false"
      :isHideCloseButton="true"
    >
      <div v-html="$t('common.modal.content_report_success.message')"></div>
    </CustomModal>
  </div>
</template>

<script>
export default {
  name: 'report-content',

  props: {
    card: {
      type: Object,
      default: () => {},
    },
    page: {
      type: Object,
      default: () => {},
    },
    selectedOption: {
      type: Number,
      default: 0,
    },
    answerOption: {
      type: Number,
      default: 0,
    },
    enteredValue: {
      type: String,
      default: '',
    },
    answerValue: {
      type: String,
      default: '',
    },
    quizSolved: {
      type: Boolean,
      default: false,
    },
    isCorrect: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShowContentReportSuccessModal: false,
      isShowContentReportModal: false,
      isShowConfirmContentReportModal: false,
    };
  },

  methods: {
    handleContentReportOpenClick() {
      this.isShowConfirmContentReportModal = true;
    },

    handleConfirmContentReportClick() {
      this.isShowContentReportModal = true;
      this.isShowConfirmContentReportModal = false;
    },

    handleContentReportSent() {
      this.isShowContentReportModal = false;
      this.isShowContentReportSuccessModal = true;
    },
  },


};
</script>

<style lang="scss" scoped>
  .report-content {
    float: right;

    .report-content-button {
      font-size: 14px;
      color: #808080;
      border: 1px solid #cccccc;
      background: none;
      border-radius: 4px;
      float: right;
      cursor: pointer;
      height: 24px;

      .icon {
        width: 14px;
        height: 14px;
      }
    }
  }
</style>
